import { PERMISSION_TYPE_E } from "../types";

export const ROWS_PER_PAGE = 20;

export const ALERT_EVENT_LOGS_REQUEST_TIME_FORMAT = "DD-MM-YYYY_HH:mm";
export const TIME_FILTER_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const TIME_FILTER_URL_FORMAT = "YYYY-MM-DD_HH-mm-ss";

export const DASHBOARD_EVENTS_REFRESH_INTERVAL = 15; // IN SECONDS

export const DEFAULT_JURISDICTION_PARENT = 1;

export const BBOX_STROKE_COLOR = "#05ff05";
export const BBOX_STROKE_WIDTH = 1.25;

export const VALIDATION_REGEX = {
	PASSWORD: {
		CASE: /(?=.*[a-z])(?=.*[A-Z])/,
		SPECIAL_CHAR: /(?=.*[0-9])(?=.*[@!_%&*])/,
		COMPLETE: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@!_%&*])/
	},
	NUMBER_PLATE:
		/^([A-Za-z]{2}[0-9]{1,2}[A-Za-z]{1,3}[0-9]{2,4})|([0-9]{2}(bh|BH|bH|Bh)[0-9]{4}[A-Za-z]{1,2})|([A-Za-z]{2}[0-9]{6})|([A-Za-z]{3}[0-9]{4})/,
	IP_V4_ADDRESS:
		/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
	ALPHA_NUMERIC: /^[a-zA-Z0-9]*$/,
	RTO_CODE: /^([A-Za-z]{2}[0-9]{1,2})/,
	MOBILE_NUMBER: /^[6-9]{1}\d{9}$/,
	EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
};

export const permissionMapping: { [key in PERMISSION_TYPE_E]: string } = {
	[PERMISSION_TYPE_E.USER_MANAGEMENT]: "User Management",
	[PERMISSION_TYPE_E.DASHBOARD]: "Dashboard",
	[PERMISSION_TYPE_E.VIOLATION_LOGS]: "Violation Logs",
	// [PERMISSION_TYPE_E.VALIDATE_VIOLATIONS]: "Validate Violations (Approve / Reject / Remark)",
	// [PERMISSION_TYPE_E.EXPORT_VIOLATIONS]: "Export Violations (CSV / PDF)",
	// [PERMISSION_TYPE_E.JURISDICTION_BOUNDARIES]: "Jurisdiction Boundaries",
	[PERMISSION_TYPE_E.RTO_METADATA]: "RTO / Jurisdiction Metadata",
	[PERMISSION_TYPE_E.INTERCEPTOR_VEHICLES]: "Interceptor Vehicles",
	// [PERMISSION_TYPE_E.DEVICE_HEALTH_MONITORING]: "Device Health Monitoring",
	[PERMISSION_TYPE_E.USER_SESSION_MANAGEMENT]: "User Session Management",
	[PERMISSION_TYPE_E.RESET_USER_ACCOUNT]: "Reset User Password / Deactivate User",
	[PERMISSION_TYPE_E.USER_ACTIVITY_LOGS]: "User Activity Logs",
	[PERMISSION_TYPE_E.SYSTEM_CONFIGURATION]: "System Configuration Settings"
	// [PERMISSION_TYPE_E.ACCESS_REPORTS]: "Reports / MIS",
	// [PERMISSION_TYPE_E.DOWNLOAD_REPORTS]: "Download / Print Reports",
	// [PERMISSION_TYPE_E.AUDIT_LOGS]: "Audit Logs",
	// [PERMISSION_TYPE_E.CHALLAN_STATUS_VIEW]: "Challan Status"
};

export const COLORS = {
	approved: "#10b981",
	pending: "#f59e0b",
	rejected: "#ef4444"
};

export const NON_HSRP_VIOLATION_NAMES = ["NON_HSRP", "NON-HSRP"];
